import { MAP_LAYER_IDS } from '../../../lib/constants';

export default (dispatch, ownProps) => {
  // const updateFeature = (updates) => {
  //   const feature = ownProps.selectedFeature;

  //   const updatedFeature = {
  //     ...feature,
  //     ...updates,
  //   };

  //   dispatch({
  //     type: 'map/closePopup',
  //   });

  //   dispatch({
  //     type: 'features/updateSelectedFeature',
  //     payload: updatedFeature,
  //   });
  //   dispatch({
  //     type: 'features/updateFeature',
  //     payload: updatedFeature,
  //   });
  //   dispatch({
  //     type: 'map/updateFeatureGraphic',
  //     payload: {
  //       feature: updatedFeature,
  //       layerId: MAP_LAYER_IDS.content,
  //     },
  //   });

  //   dispatch({
  //     type: 'map/updateFeatureGraphicAttributes',
  //     payload: {
  //       featureId: updatedFeature.uuid,
  //       layerId: MAP_LAYER_IDS.content,
  //       attributes: updates,
  //     },
  //   });
  // };

  return {
    saveRefs: (map, mapView, sceneView) => {
      dispatch({
        type: 'map/initializeRefs',
        payload: {
          mapRef: map,
          mapViewRef: mapView,
          sceneViewRef: sceneView,
        },
      });
    },
    // featureClicked: (featureId) => {
    //   return dispatch({
    //     type: 'features/getFeature',
    //     payload: featureId,
    //     callback: (feature) => {
    //       dispatch({
    //         type: 'map/setSelectedFeature',
    //         payload: feature,
    //       });
    //       dispatch({
    //         type: 'features/setPreviousFeatureState',
    //         payload: feature,
    //       });
    //     },
    //   });
    // },
    setSceneError: (error) => {
      dispatch({
        type: 'map/setSceneError',
        payload: error,
      });
    },
  };
};
